import React from 'react'
import PropTypes from 'prop-types'
import { useFormContext } from 'react-hook-form'

import { Icon } from '@/components/common'
import { ruleStates, schemaOnlyMessages, RULE_STATE } from '@/utils/passwordSchema'

import styles from './PasswordRuleChecklist.module.scss'

// The neutral state is a bullet, not a status, so it has no icon — `.icon`
// renders it as a CSS dot. `check`/`close` with the `fill` prop follow the
// in-repo precedent in blocks/CompareTable.js; nui's `success`/`error`
// are seal-shaped and carry per-path fills that defeat `fill`.
const ICONS = {
  [RULE_STATE.SATISFIED]: { fill: 'success', name: 'check' },
  [RULE_STATE.FAILED]: { fill: 'error', name: 'close' },
}

const PasswordRuleChecklist = ({ name = 'password' }) => {
  const { watch, formState } = useFormContext()

  const value = watch(name) ?? ''
  const types = formState.errors?.[name]?.types
  const rules = ruleStates(value, types)
  const messages = schemaOnlyMessages(types)

  return (
    <div data-testid="password-rule-checklist">
      <ul className={styles.list}>
        {rules.map(({ name: ruleName, label, state }) => {
          const icon = ICONS[state]
          return (
            <li
              key={ruleName}
              className={`${styles.rule} ${styles[state]}`}
              data-rule={ruleName}
              data-state={state}
            >
              <span aria-hidden className={styles.icon}>
                {icon && <Icon fill={icon.fill} name={icon.name} size="xsmall" />}
              </span>
              {label}
            </li>
          )
        })}
      </ul>
      {messages.map(message => (
        <p key={message} className={styles.message}>{message}</p>
      ))}
    </div>
  )
}

PasswordRuleChecklist.propTypes = {
  name: PropTypes.string,
}

export default PasswordRuleChecklist
